import styled from 'styled-components'
import { themeVariables } from '../themes/themeVariables'

export const Separator = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${themeVariables.colors.border};
`
